import {ReadyProvider} from '../../../application/providers/readyProvider';
import {SubscriptionForm} from '../subscription/subscriptionForm';

ReadyProvider.executeOnReady(() => {
    new SubscriptionForm(document.querySelector('[data-subsctiption="form"]'));
});
